import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, of } from 'rxjs';

@Injectable()
export class PacimHttpErrorHandlerService {
  constructor(private readonly messageService: MessageService) {}

  /** Create curried handleError function that already knows the service name */
  createHandleError =
    (serviceName = '') =>
    <T>(operation = 'operation', result = {} as T) =>
      this.handleError(serviceName, operation, result)

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError = (serviceName = '', operation = 'operation', result = {}) => {
    // tslint:disable-next-line: no-any
    return (error: HttpErrorResponse): Observable<any> => {
      // Let the app keep running by returning a safe result.
      return of(result);
    };
  }
}
